import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiHeader from "../../components/MuiHeader";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AodIcon from "@mui/icons-material/Aod";
import UndoIcon from "@mui/icons-material/Undo";
import AddIcon from "@mui/icons-material/Add";
import { red, blue, green, purple } from "@mui/material/colors";
// MUI
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { usertype_change } from "./TeacherCategory.Slice";
import {
  getTeacherBaselineThunk,
  createTeacherBaselineThunk,
  updateTeacherBaselineThunk,
  deleteTeacherBaselineThunk,
} from "./TeacherCategory.Thunk";

const TeacherCategoryPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // -------------- Card-item vertical menu ---------------
  const ITEM_HEIGHT = 48;
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [recordId, setRecordId] = useState("");
  const [selectedSkillsetId, setSelectedSkillsetId] = useState("");
  const [selectedSkillsetName, setSelectedSkillsetName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const handleVertMenuClick = (event, _id, categoryId, categoryName, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
    setRecordId(_id);
    setSelectedSkillsetId(categoryId);
    setSelectedSkillsetName(categoryName);
  };
  const handleVertMenuClose = () => {
    setAnchorEl(null);
  };
  // ---------------------------------------------

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------

  // ---------------- navigate to skillset manager -------------
  const navigate_to = () => {
    navigate("/teacherbaseline");
  };
  // ------------------------------------------------------------

  // --------- options for dropdowns ---------
  const usertype_select_option_list = [
    { value: "fellow", text: "Educator" },
    { value: "school", text: "School" },
    { value: "anganwadi", text: "Anganwadi" },
  ];

  // ------------ dropdowns on change ----------------
  const usertype_select_onchange = (event) => {
    dispatch(usertype_change(event.target.value));
  };

  const data = useSelector((state) => state.TeacherCategorySlice.category);

  // ------------ Load data & skill ----------------

  const categoryId = useSelector(
    (state) => state.TeacherCategorySlice.categoryId
  );

  const categoryName = useSelector(
    (state) => state.TeacherCategorySlice.categoryName
  );

  const usertype = useSelector((state) => state.TeacherCategorySlice.usertype);
  const disable_content_button = useSelector(
    (state) => state.TeacherCategorySlice.disable_content_button
  );

  useEffect(() => {
    const load_data = () => {
      const params = { categoryId, categoryName, usertype };
      dispatch(getTeacherBaselineThunk(params));
    };
    load_data();
  }, [dispatch, categoryId, categoryName, usertype]);

  // -----------------------------------------------

  // ----------- create, update delete button click ----------
  const create_content_button_click = () => {
    Swal.fire({
      title: "CREATE NEW CATEGORY",
      input: "text",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Save",
      showLoaderOnConfirm: true,
      preConfirm: (input_value) => {
        if (
          input_value === undefined ||
          input_value === null ||
          input_value.length <= 0
        )
          toast.error("Enter a valid skillset name");
        else {
          const body = {
            categoryId: new Date().getTime(),
            categoryName: input_value,
            usertype: usertype,
          };

          dispatch(createTeacherBaselineThunk(body)).then(() => {
            const params = { categoryId, categoryName, usertype };
            dispatch(getTeacherBaselineThunk(params));
            toast.success("Changes made successfully");
          });
        }
      },
    });
  };

  const update_content_button_click = (_id, categoryName) => {
    handleVertMenuClose();
    Swal.fire({
      title: "UPDATE CATEGORY",
      input: "text",
      inputValue: categoryName,
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Update",
      showLoaderOnConfirm: true,
      preConfirm: (input_value) => {
        if (input_value === categoryName) toast.error("No changes made");
        else if (
          input_value === undefined ||
          input_value === null ||
          input_value.length <= 0
        )
          toast.error("Enter a valid category name");
        else {
          const params = {
            _id: _id,
            body: {
              categoryName: input_value,
            },
          };
          dispatch(updateTeacherBaselineThunk(params)).then(() => {
            const params = { categoryId, categoryName, usertype };
            dispatch(getTeacherBaselineThunk(params));
            toast.success("Changes made successfully");
          });
        }
      },
    });
  };

  const delete_content_button_click = (_id) => {
    handleVertMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteTeacherBaselineThunk(_id)).then(() => {
          const params = { categoryId, categoryName, usertype };
          dispatch(getTeacherBaselineThunk(params));
          toast.success("Changes made successfully");
        });
      }
    });
  };

  return (
    <>
      <div>
        <MuiHeader header="Teacher Category" />

        <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Usertype</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={usertype}
            label="Language"
            onChange={usertype_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {usertype_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          onClick={navigate_to}
          variant="outlined"
          sx={{
            minWidth: 80,
            alignItem: "right",
            backgroundColor: "blue",
            color: "black",
          }}
          size="small">
          <UndoIcon style={{ color: "orange" }}></UndoIcon>
          Back
        </Button>
      </div>

      {/* Show List */}
      <div>
        <Button onClick={create_content_button_click} variant="contained">
          <AddIcon />
          Create New
        </Button>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={3}>
            {data.map((eachskill, index) => (
              <Grid item xs={12} sm={isSmallScreen ? 12 : 6} md={4} key={index}>
                <Card sx={{ maxWidth: 345 }}>
                  <CardHeader
                    avatar={
                      <Avatar sx={{ bgcolor: purple[500] }}>
                        <AodIcon />
                      </Avatar>
                    }
                    action={
                      <>
                        <IconButton
                          id={index + 1.1}
                          onClick={(e) =>
                            handleVertMenuClick(
                              e,
                              eachskill._id,
                              eachskill.categoryId,
                              eachskill.categoryName,
                              index
                            )
                          }
                          aria-controls={openVertMenu ? { index } : undefined}
                          aria-expanded={openVertMenu ? "true" : undefined}
                          aria-haspopup="true">
                          <MoreVertIcon />
                        </IconButton>
                      </>
                    }
                    title={
                      <div style={{ cursor: "pointer" , wordBreak: "break-all"}}>
                        {eachskill.categoryName}
                      </div>
                    }
                  />
                </Card>
              </Grid>
            ))}
            <Menu
              id={selectedIndex}
              anchorEl={anchorEl}
              open={openVertMenu}
              onClose={handleVertMenuClose}
              MenuListProps={{
                "aria-labelledby": "vert-button",
              }}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: "20ch",
                },
              }}>
              <MenuItem
                onClick={() =>
                  update_content_button_click(recordId, selectedSkillsetName)
                }>
                Edit
              </MenuItem>
              <MenuItem onClick={() => delete_content_button_click(recordId)}>
                Delete
              </MenuItem>
            </Menu>
          </Grid>
        </Box>
      </div>
      {/* Toaster */}
      <ToastContainer />
    </>
  );
};

export default TeacherCategoryPage;